import { ProblemTypeOptions, TypeProblemTypeOptions } from "@/domains/model/modelOptions";

export const isConceptShiftEnabled = (problemType?: TypeProblemTypeOptions) => {
  return problemType === ProblemTypeOptions.BinaryClassification;
};
